(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-strikeman-expansion-product]'));
  if (!roots.length) return;

  function injectGalleryArrowStyle() {
    if (document.getElementById('strikeman-expansion-gallery-arrow-style')) return;
    var style = document.createElement('style');
    style.id = 'strikeman-expansion-gallery-arrow-style';
    style.textContent = [
      '.sep-gallery-card .sep-main-media{margin-right:52px;}',
      '.sep-gallery-card .sep-gallery-arrow{z-index:4;}',
      '.sep-gallery-card .sep-gallery-arrow--prev{left:88px;}',
      '.sep-gallery-card .sep-gallery-arrow--next{right:18px;}',
      '@media screen and (max-width:749px){.sep-gallery-card .sep-main-media{margin-right:-15px;}.sep-gallery-card .sep-gallery-arrow{display:none;}}'
    ].join('');
    document.head.appendChild(style);
  }

  injectGalleryArrowStyle();

  function normalizeReviewText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getJudgeReviewRating(reviewNode) {
    var ratingNode = reviewNode.querySelector('[data-score]');
    var score = Number(ratingNode && ratingNode.getAttribute('data-score'));
    var filledStars = reviewNode.querySelectorAll('.jdgm-rev__rating .jdgm-star.jdgm--on, .jdgm-rev__rating .jdgm-star.jdgm--half').length;
    var rating = filledStars || score || 5;
    return Math.max(1, Math.min(5, Math.round(rating)));
  }

  function extractJudgeReview(reviewNode) {
    var bodyNode = reviewNode.querySelector('.jdgm-rev__body');
    var titleNode = reviewNode.querySelector('.jdgm-rev__title');
    var authorNode = reviewNode.querySelector('.jdgm-rev__author');
    var locationNode = reviewNode.querySelector('.jdgm-rev__location');
    var body = normalizeReviewText(bodyNode && bodyNode.textContent);
    var title = normalizeReviewText(titleNode && titleNode.textContent);
    var author = normalizeReviewText(authorNode && authorNode.textContent) || 'Verified buyer';
    var location = normalizeReviewText(locationNode && locationNode.textContent).replace(/[()]/g, '');
    var copy = body || title;

    if (!copy || copy.length < 8) return null;

    return {
      rating: getJudgeReviewRating(reviewNode),
      copy: copy,
      buyer: 'Verified buyer - ' + author + (location ? ' / ' + location : '')
    };
  }

  function buildProductReviewCard(review) {
    var card = document.createElement('article');
    var stars = document.createElement('div');
    var copy = document.createElement('p');
    var buyer = document.createElement('strong');

    card.className = 'sep-review-card';
    stars.textContent = '★★★★★'.slice(0, review.rating);
    stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
    copy.textContent = review.copy;
    buyer.textContent = review.buyer;

    card.appendChild(stars);
    card.appendChild(copy);
    card.appendChild(buyer);
    return card;
  }

  roots.forEach(function (root) {
    function updateSaleTimer() {
      var timer = root.querySelector('[data-sep-sale-timer]');
      if (!timer) return;
      var now = new Date();
      var cycleEnd = new Date(now);
      cycleEnd.setHours(24, 0, 0, 0);
      var distance = Math.max(0, cycleEnd.getTime() - now.getTime());
      var hours = Math.floor(distance / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);
      var hoursNode = timer.querySelector('[data-sep-sale-timer-hours]');
      var minutesNode = timer.querySelector('[data-sep-sale-timer-minutes]');
      var secondsNode = timer.querySelector('[data-sep-sale-timer-seconds]');
      if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
      if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
      if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');
      timer.setAttribute('aria-label', 'Offer ends in ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds');
    }

    if (root.querySelector('[data-sep-sale-timer]')) {
      updateSaleTimer();
      window.setInterval(updateSaleTimer, 1000);
    }

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sep-thumb]'));
    var currentMediaIndex = 0;
    var mobileGalleryQuery = window.matchMedia('(max-width: 749px)');
    var mediaPayload = [];
    var mediaPayloadNode = root.querySelector('[data-sep-media-payload]');

    function closeImageModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('sep-image-modal-open');
      var image = modal.querySelector('[data-sep-image-modal-img]');
      if (image) image.removeAttribute('src');
    }

    function getImageModal() {
      var modal = document.querySelector('[data-sep-image-modal]');
      if (modal) return modal;

      modal = document.createElement('div');
      modal.className = 'sep-image-modal';
      modal.setAttribute('data-sep-image-modal', '');
      modal.hidden = true;
      modal.innerHTML = [
        '<button class="sep-image-modal__backdrop" type="button" data-sep-image-modal-close aria-label="Close image preview"></button>',
        '<div class="sep-image-modal__dialog" role="dialog" aria-modal="true" aria-label="Product image preview">',
        '<button class="sep-image-modal__close" type="button" data-sep-image-modal-close>Close</button>',
        '<img class="sep-image-modal__image" data-sep-image-modal-img alt="">',
        '</div>'
      ].join('');
      document.body.appendChild(modal);

      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-sep-image-modal-close]')) closeImageModal(modal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeImageModal(modal);
      });

      return modal;
    }

    function openImageModal(src, alt) {
      if (!src) return;
      var modal = getImageModal();
      var image = modal.querySelector('[data-sep-image-modal-img]');
      if (!image) return;
      image.src = src;
      image.alt = alt || 'Product image';
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.classList.add('sep-image-modal-open');
      var close = modal.querySelector('.sep-image-modal__close');
      if (close) close.focus({ preventScroll: true });
    }

    if (mediaPayloadNode) {
      try {
        mediaPayload = JSON.parse(mediaPayloadNode.textContent || '[]');
      } catch (error) {
        mediaPayload = [];
      }
    }

    function setActiveMedia(index) {
      if (!thumbs.length) return;
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentMediaIndex = index;
      var firstImageBadge = root.querySelector('[data-sep-first-image-badge]');
      if (firstImageBadge) firstImageBadge.hidden = index !== 0;

      var thumb = thumbs[index];
      var mainMedia = root.querySelector('.sep-main-media');
      if (!thumb || !mainMedia) return;

      var alt = thumb.dataset.alt || '';
      if (thumb.dataset.mediaType === 'video' && thumb.dataset.videoSrc) {
        mainMedia.innerHTML = [
          '<video class="sep-main-video" controls playsinline preload="metadata" poster="' + (thumb.dataset.src || '') + '">',
          '<source src="' + thumb.dataset.videoSrc + '" type="' + (thumb.dataset.videoType || 'video/mp4') + '">',
          '</video>'
        ].join('');
      } else if (thumb.dataset.src) {
        mainMedia.innerHTML = '<img class="sep-main-image" src="' + thumb.dataset.src + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
      }

      thumbs.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });

      var count = root.querySelector('[data-sep-gallery-count]');
      if (count) count.textContent = (index + 1) + ' / ' + thumbs.length;
    }

    function setMainImage(src, alt) {
      var mainMedia = root.querySelector('.sep-main-media');
      if (!mainMedia || !src) return;
      mainMedia.innerHTML = '<img class="sep-main-image" src="' + src + '" alt="' + String(alt || '').replace(/"/g, '&quot;') + '">';
      thumbs.forEach(function (item) {
        item.classList.remove('is-active');
      });
      var firstImageBadge = root.querySelector('[data-sep-first-image-badge]');
      if (firstImageBadge) firstImageBadge.hidden = true;
    }

    function escapeAttribute(value) {
      return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function normalizeGallerySrc(src) {
      return String(src || '').split('?')[0].replace(/^https?:/, '');
    }

    function addGalleryItem(items, seen, item) {
      if (!item || !item.src) return;
      var key = normalizeGallerySrc(item.src);
      if (!key || seen[key]) return;
      seen[key] = true;
      items.push({
        src: item.src,
        thumb: item.thumb || item.src,
        alt: item.alt || 'Expansion pack target'
      });
    }

    function parseImageList(imageList) {
      if (!imageList) return [];
      return imageList.split('::').map(function (item) {
        var parts = item.split('||');
        return {
          src: parts[0] || '',
          thumb: parts[0] || '',
          alt: parts[1] || 'Expansion pack target'
        };
      }).filter(function (item) {
        return !!item.src;
      });
    }

    function getOptionGalleryItems(option) {
      var items = [];
      var seen = {};
      var keywords = String(option && option.dataset.galleryKeywords || '')
        .split('|')
        .map(function (keyword) { return keyword.trim().toLowerCase(); })
        .filter(Boolean);

      if (option && option.dataset.image) {
        addGalleryItem(items, seen, {
          src: option.dataset.image,
          thumb: option.dataset.image,
          alt: option.dataset.title || option.textContent.trim()
        });
      }

      parseImageList(option && option.dataset.extraImages).forEach(function (item) {
        addGalleryItem(items, seen, item);
      });

      if (keywords.length) {
        mediaPayload.forEach(function (item) {
          var searchable = String((item.src || '') + ' ' + (item.alt || '')).toLowerCase();
          var matches = keywords.some(function (keyword) {
            return searchable.indexOf(keyword) >= 0;
          });
          if (matches) addGalleryItem(items, seen, item);
        });
      }

      if (!items.length) {
        mediaPayload.forEach(function (item) {
          addGalleryItem(items, seen, item);
        });
      }

      return items;
    }

    function createGalleryImageThumb(item, index) {
      var thumb = document.createElement('button');
      thumb.className = 'sep-thumb';
      thumb.type = 'button';
      thumb.setAttribute('data-sep-thumb', '');
      thumb.setAttribute('data-sep-generated-thumb', '');
      thumb.dataset.mediaType = 'image';
      thumb.dataset.src = item.src;
      thumb.dataset.alt = item.alt;
      thumb.setAttribute('aria-label', 'View expansion pack image ' + index);
      thumb.innerHTML = '<img src="' + escapeAttribute(item.thumb || item.src) + '" alt="' + escapeAttribute(item.alt) + '" loading="lazy">';
      return thumb;
    }

    function rebuildVariantGallery(option) {
      var parent = root.querySelector('.sep-thumbs');
      if (!parent) {
        thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sep-thumb]'));
        return false;
      }

      Array.prototype.slice.call(parent.querySelectorAll('[data-sep-thumb][data-media-type="image"]')).forEach(function (thumb) {
        thumb.remove();
      });

      var galleryItems = getOptionGalleryItems(option);
      var videoThumb = root.querySelector('[data-sep-hero-video-thumb]');
      var insertAfterVideo = videoThumb;

      galleryItems.forEach(function (item, itemIndex) {
        var thumb = createGalleryImageThumb(item, itemIndex + 1);
        if (itemIndex === 0 && videoThumb) {
          parent.insertBefore(thumb, videoThumb);
        } else if (insertAfterVideo && insertAfterVideo.nextSibling) {
          parent.insertBefore(thumb, insertAfterVideo.nextSibling);
          insertAfterVideo = thumb;
        } else if (insertAfterVideo) {
          parent.appendChild(thumb);
          insertAfterVideo = thumb;
        } else {
          parent.appendChild(thumb);
        }
      });

      thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sep-thumb]'));
      return !!galleryItems.length;
    }

    function syncCustomSelect() {
      var select = root.querySelector('[data-sep-variant-select]');
      var shell = root.querySelector('[data-sep-pack-shell]');
      if (!select || !shell) return;
      var label = shell.querySelector('[data-sep-select-label]');
      var selectedOption = select.options[select.selectedIndex];
      if (label && selectedOption) {
        label.textContent = '';
        var title = document.createElement('span');
        title.textContent = selectedOption.dataset.title || selectedOption.textContent.replace(/\s*\(OUT OF STOCK\)\s*$/i, '').trim();
        label.appendChild(title);
        if (selectedOption.dataset.available === 'false') {
          var status = document.createElement('span');
          status.className = 'sep-select-status';
          status.textContent = ' (OUT OF STOCK)';
          label.appendChild(status);
        }
      }
      shell.querySelectorAll('[data-sep-select-option]').forEach(function (option) {
        option.setAttribute('aria-selected', option.dataset.value === select.value ? 'true' : 'false');
      });
    }

    function openCustomSelect() {
      var shell = root.querySelector('[data-sep-pack-shell]');
      if (!shell) return;
      var toggle = shell.querySelector('[data-sep-select-toggle]');
      var menu = shell.querySelector('[data-sep-select-menu]');
      if (!toggle || !menu) return;
      shell.classList.add('is-open');
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeCustomSelect() {
      var shell = root.querySelector('[data-sep-pack-shell]');
      if (!shell) return;
      var toggle = shell.querySelector('[data-sep-select-toggle]');
      var menu = shell.querySelector('[data-sep-select-menu]');
      shell.classList.remove('is-open');
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function chooseCustomSelectOption(option) {
      var select = root.querySelector('[data-sep-variant-select]');
      if (!select || !option) return;
      select.value = option.dataset.value || '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      closeCustomSelect();
    }

    function updatePackVideo(option) {
      if (!option) return;
      var videoSrc = option.dataset.videoSrc || '';
      var videoType = option.dataset.videoType || 'video/mp4';
      var poster = option.dataset.image || '';
      var heroVideoThumb = root.querySelector('[data-sep-hero-video-thumb]');

      if (heroVideoThumb && videoSrc) {
        heroVideoThumb.dataset.videoSrc = videoSrc;
        heroVideoThumb.dataset.videoType = videoType;
        if (poster) {
          heroVideoThumb.dataset.src = poster;
          var thumbImage = heroVideoThumb.querySelector('img');
          if (thumbImage) thumbImage.src = poster;
        }
      }
    }

    function syncQuantities(value) {
      root.querySelectorAll('[data-sep-qty-input]').forEach(function (input) {
        input.value = value;
      });
    }

    var selectedVariant = null;
    var successfulNotifications = {};

    function setNotifyMessage(notify, message, state) {
      var status = notify ? notify.querySelector('[data-spp-notify-status]') : null;
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', state === 'error');
      status.classList.toggle('is-success', state === 'success');
    }

    function updateNotifyState(variant) {
      var shouldShow = !!variant && variant.available === false;
      var shouldShowPurchase = !!variant && variant.available === true;
      var stickyBar = root.querySelector('[data-sep-sticky-atc]');
      if (stickyBar) stickyBar.classList.toggle('is-notify-active', shouldShow);

      root.querySelectorAll('.sep-purchase-row').forEach(function (row) {
        row.hidden = !shouldShowPurchase;
        row.setAttribute('aria-hidden', shouldShowPurchase ? 'false' : 'true');
      });
      root.querySelectorAll('[data-sep-sticky-purchase]').forEach(function (purchase) {
        purchase.hidden = shouldShow;
        purchase.setAttribute('aria-hidden', shouldShow ? 'true' : 'false');
      });
      root.querySelectorAll('[data-spp-notify]').forEach(function (notify) {
        notify.hidden = !shouldShow;
        notify.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        notify.dataset.variantId = shouldShow ? String(variant.id || '') : '';
        notify.dataset.variantTitle = shouldShow ? String(variant.title || '') : '';
        notify.dataset.variantSku = shouldShow ? String(variant.sku || '') : '';
        if (!shouldShow) {
          setNotifyMessage(notify, '', '');
          var input = notify.querySelector('[data-spp-notify-email]');
          if (input) input.removeAttribute('aria-invalid');
        }
      });
    }

    function submitBackInStockNotification(notify) {
      if (!notify || !selectedVariant || selectedVariant.available !== false) return;
      var submittedVariantId = String(selectedVariant.id || '');
      var input = notify.querySelector('[data-spp-notify-email]');
      var button = notify.querySelector('[data-spp-notify-submit]');
      var email = input ? input.value.trim() : '';

      if (!input || !email || !input.validity.valid) {
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
        setNotifyMessage(notify, 'Enter a valid email address.', 'error');
        return;
      }

      input.removeAttribute('aria-invalid');
      var submissionKey = submittedVariantId + '|' + email.toLowerCase();
      if (successfulNotifications[submissionKey]) {
        setNotifyMessage(notify, 'You\u2019re on the list. We\u2019ll email you when this item is back in stock.', 'success');
        return;
      }
      if (typeof window.maestra !== 'function') {
        setNotifyMessage(notify, 'The notification service is unavailable. Please try again.', 'error');
        return;
      }

      var completed = false;
      var timeout = window.setTimeout(function () {
        if (completed) return;
        completed = true;
        if (button) {
          button.disabled = false;
          button.textContent = 'Notify me';
        }
        setNotifyMessage(notify, 'Something went wrong. Please try again.', 'error');
      }, 15000);

      if (button) {
        button.disabled = true;
        button.textContent = 'Submitting...';
      }
      setNotifyMessage(notify, '', '');

      function finish(state) {
        if (completed) return;
        completed = true;
        window.clearTimeout(timeout);
        if (button) {
          button.disabled = false;
          button.textContent = 'Notify me';
        }
        if (notify.dataset.variantId !== submittedVariantId) return;
        if (state === 'success') {
          successfulNotifications[submissionKey] = true;
          setNotifyMessage(notify, 'You\u2019re on the list. We\u2019ll email you when this item is back in stock.', 'success');
        } else {
          setNotifyMessage(notify, 'Something went wrong. Please try again.', 'error');
        }
      }

      window.maestra('async', {
        operation: 'BackInStock',
        data: {
          customer: { firstName: '', lastName: '', email: email },
          addProductToList: {
            product: { ids: { shopifyIDStrikeman: submittedVariantId } }
          }
        },
        onSuccess: function () { finish('success'); },
        onError: function () { finish('error'); },
        onValidationError: function () { finish('error'); }
      });
    }

    root.querySelectorAll('[data-spp-notify]').forEach(function (notify) {
      var button = notify.querySelector('[data-spp-notify-submit]');
      var input = notify.querySelector('[data-spp-notify-email]');
      if (button) button.addEventListener('click', function () { submitBackInStockNotification(notify); });
      if (input) input.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        submitBackInStockNotification(notify);
      });
    });

    function updateSelectedVariant() {
      var select = root.querySelector('[data-sep-variant-select]');
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var variantId = option.value || '';
      var isAvailable = option.dataset.available !== 'false';
      var sale = root.querySelector('[data-sep-sale]');
      var compare = root.querySelector('[data-sep-compare]');

      root.querySelectorAll('[data-sep-variant-input]').forEach(function (input) {
        input.value = variantId;
      });

      if (sale && option.dataset.price) sale.textContent = option.dataset.price;
      if (compare && option.dataset.compare) compare.textContent = option.dataset.compare;

      updatePackVideo(option);
      var hasVariantGallery = rebuildVariantGallery(option);
      syncCustomSelect();

      var packCopy = root.querySelector('[data-sep-pack-copy]');
      if (packCopy && option.dataset.copy) packCopy.textContent = option.dataset.copy;

      selectedVariant = {
        id: variantId,
        title: option.dataset.title || option.textContent.trim(),
        sku: option.dataset.sku || '',
        available: isAvailable
      };
      updateNotifyState(selectedVariant);

      root.querySelectorAll('[data-sep-add]').forEach(function (button) {
        button.disabled = !isAvailable;
        button.textContent = isAvailable ? (button.dataset.sepReadyLabel || 'Add to cart') : 'Sold out';
      });

      if (variantId && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (error) {
          // Keep the selected pack active if URL APIs are unavailable.
        }
      }

      if (option.dataset.image) {
        var imageIndex = thumbs.findIndex(function (thumb) {
          return thumb.dataset.mediaType === 'image' && thumb.dataset.src === option.dataset.image;
        });
        if (imageIndex >= 0) setActiveMedia(imageIndex);
        else setMainImage(option.dataset.image, option.dataset.title || option.textContent.trim());
      } else if (hasVariantGallery) {
        setActiveMedia(0);
      }
    }

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-sep-select-toggle]');
      if (toggle && root.contains(toggle)) {
        event.preventDefault();
        var shell = toggle.closest('[data-sep-pack-shell]');
        if (shell && shell.classList.contains('is-open')) closeCustomSelect();
        else openCustomSelect();
        return;
      }

      var selectOption = event.target.closest('[data-sep-select-option]');
      if (selectOption && root.contains(selectOption)) {
        event.preventDefault();
        chooseCustomSelectOption(selectOption);
        return;
      }

      var mainImage = event.target.closest('.sep-main-image');
      if (mainImage && root.contains(mainImage)) {
        event.preventDefault();
        openImageModal(mainImage.currentSrc || mainImage.src, mainImage.alt);
        return;
      }

      var thumb = event.target.closest('[data-sep-thumb]');
      if (thumb && root.contains(thumb)) {
        var index = thumbs.indexOf(thumb);
        if (index >= 0) setActiveMedia(index);
        return;
      }

      if (event.target.closest('[data-sep-gallery-prev]')) {
        setActiveMedia(currentMediaIndex - 1);
        return;
      }

      if (event.target.closest('[data-sep-gallery-next]')) {
        setActiveMedia(currentMediaIndex + 1);
        return;
      }

      var qtyRoot = event.target.closest('[data-sep-qty]');
      if (!qtyRoot || !root.contains(qtyRoot)) return;
      var input = qtyRoot.querySelector('[data-sep-qty-input]');
      if (!input) return;
      var value = Math.max(1, parseInt(input.value || '1', 10));
      if (event.target.closest('[data-sep-qty-minus]')) value -= 1;
      if (event.target.closest('[data-sep-qty-plus]')) value += 1;
      input.value = Math.max(1, value);
      syncQuantities(input.value);
    });

    root.querySelectorAll('[data-sep-qty-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        syncQuantities(Math.max(1, parseInt(input.value || '1', 10)));
      });
    });

    var gallery = root.querySelector('[data-sep-gallery]');
    if (gallery) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swipeLastX = 0;
      var swipeLastY = 0;
      var isGallerySwipe = false;

      function shouldIgnoreGallerySwipe(target) {
        return !!target.closest('[data-sep-thumb], [data-sep-gallery-prev], [data-sep-gallery-next], button, a, input, select, textarea');
      }

      gallery.addEventListener('touchstart', function (event) {
        if (!mobileGalleryQuery.matches || event.touches.length !== 1 || shouldIgnoreGallerySwipe(event.target)) return;
        var touch = event.touches[0];
        swipeStartX = touch.clientX;
        swipeStartY = touch.clientY;
        swipeLastX = swipeStartX;
        swipeLastY = swipeStartY;
        isGallerySwipe = true;
      }, { passive: true, capture: true });

      gallery.addEventListener('touchmove', function (event) {
        if (!isGallerySwipe || !event.touches.length) return;
        var touch = event.touches[0];
        swipeLastX = touch.clientX;
        swipeLastY = touch.clientY;
      }, { passive: true, capture: true });

      gallery.addEventListener('touchend', function () {
        if (!isGallerySwipe) return;
        var deltaX = swipeLastX - swipeStartX;
        var deltaY = swipeLastY - swipeStartY;
        isGallerySwipe = false;

        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;
        setActiveMedia(currentMediaIndex + (deltaX < 0 ? 1 : -1));
      }, { passive: true, capture: true });
    }

    var variantSelect = root.querySelector('[data-sep-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', updateSelectedVariant);
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest || target.closest('[data-sep-pack-shell]')) return;
      closeCustomSelect();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCustomSelect();
    });

    root.querySelectorAll('form[data-sep-product-form], form[data-sep-sticky-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var variantInput = form.querySelector('[data-sep-variant-input]');
        if (!variantInput || !variantInput.value) return;

        var variantSelect = root.querySelector('[data-sep-variant-select]');
        var selectedOption = variantSelect && variantSelect.options[variantSelect.selectedIndex];
        if (selectedOption && selectedOption.dataset.available === 'false') {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        var submit = form.querySelector('[data-sep-add]');
        var originalText = submit ? submit.textContent : '';
        var data = new FormData(form);
        var qty = Math.max(1, parseInt(data.get('quantity') || '1', 10));
        var cartSectionIds = Array.prototype.map.call(
          document.querySelectorAll('cart-items-component[data-section-id]'),
          function (component) { return component.dataset.sectionId; }
        ).filter(Boolean);
        if (cartSectionIds.length) {
          data.append('sections', cartSectionIds.join(','));
          data.append('sections_url', window.location.pathname);
        }
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Adding...';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function (item) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  source: 'product-form-component',
                  itemCount: qty,
                  variantId: item.id,
                  productId: item.product_id,
                  sections: item.sections
                }
              }
            }));
            if (submit) submit.textContent = 'Added';
            setTimeout(function () {
              if (submit) submit.textContent = originalText;
            }, 1600);
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (submit) submit.disabled = false;
            updateSelectedVariant();
          });
      });
    });

    var faqSearch = root.querySelector('[data-sep-faq-search]');
    if (faqSearch) {
      var faqItems = Array.prototype.slice.call(root.querySelectorAll('.sep-faq-item'));
      function updateFaqResults(query) {
        var visibleCount = 0;
        faqItems.forEach(function (item) {
          var matches = !query || item.textContent.toLowerCase().includes(query);
          item.hidden = !matches;
          if (matches) {
            if (query) item.open = visibleCount === 0;
            visibleCount += 1;
          }
        });
        var empty = root.querySelector('[data-sep-faq-empty]');
        if (empty) empty.hidden = visibleCount > 0;
      }

      faqSearch.addEventListener('input', function () {
        updateFaqResults(faqSearch.value.toLowerCase().trim());
      });
      updateFaqResults('');
    }

    var descriptionItems = root.querySelectorAll('.sep-product-description');
    descriptionItems.forEach(function (description) {
      var icon = description.querySelector('summary span:last-child');
      function updateIcon() {
        if (icon) icon.textContent = description.open ? '-' : '+';
      }
      description.addEventListener('toggle', updateIcon);
      updateIcon();
    });

    var sticky = root.querySelector('[data-sep-sticky-atc]');
    var scrollTimer;
    var lastY = window.scrollY;
    function updateStickyVisibility() {
      if (!sticky || window.matchMedia('(min-width: 750px)').matches) return;
      var movingDown = window.scrollY > lastY;
      sticky.classList.toggle('is-hidden', movingDown);
      lastY = window.scrollY;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        sticky.classList.remove('is-hidden');
      }, 220);
    }
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });

    var track = root.querySelector('[data-sep-review-track]');
    var judgeSource = root.querySelector('[data-sep-judge-source]');
    function hydrateProductReviewCards() {
      if (!track || !judgeSource || track.getAttribute('data-product-reviews-loaded') === 'true') return;
      var seenReviews = {};
      var productReviews = Array.prototype.slice.call(judgeSource.querySelectorAll('.jdgm-rev'))
        .map(extractJudgeReview)
        .filter(function (review) {
          if (!review) return false;
          var key = review.buyer + '|' + review.copy;
          if (seenReviews[key]) return false;
          seenReviews[key] = true;
          return true;
        });

      if (productReviews.length) {
        track.innerHTML = '';
        productReviews.forEach(function (review) {
          track.appendChild(buildProductReviewCard(review));
        });
        track.setAttribute('data-product-reviews-loaded', 'true');
      }
    }
    hydrateProductReviewCards();
    if (track && judgeSource && track.getAttribute('data-product-reviews-loaded') !== 'true' && window.MutationObserver) {
      var reviewObserver = new MutationObserver(hydrateProductReviewCards);
      reviewObserver.observe(judgeSource, { childList: true, subtree: true });
    }

    if (track) {
      var reviewWrap = root.querySelector('[data-sep-review-wrap]');
      var reviewExpand = root.querySelector('[data-sep-review-expand]');
      function setProductReviewsExpanded(expanded) {
        track.classList.toggle('is-expanded', expanded);
        if (reviewWrap) reviewWrap.classList.toggle('is-expanded', expanded);
        if (reviewExpand) {
          reviewExpand.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          reviewExpand.textContent = expanded ? 'Show fewer reviews' : (reviewExpand.getAttribute('data-default-label') || 'View all');
        }
        if (expanded && typeof track.scrollIntoView === 'function') {
          track.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      if (reviewExpand) {
        reviewExpand.addEventListener('click', function (event) {
          event.preventDefault();
          setProductReviewsExpanded(!track.classList.contains('is-expanded'));
        });
      }

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      track.addEventListener('pointerdown', function (event) {
        if (track.classList.contains('is-expanded')) return;
        isDown = true;
        startX = event.pageX;
        scrollLeft = track.scrollLeft;
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        track.scrollLeft = scrollLeft - (event.pageX - startX);
      });
      track.addEventListener('pointerup', function () { isDown = false; });
      track.addEventListener('pointercancel', function () { isDown = false; });

      var reviewStep = function () {
        var card = track.querySelector('.sep-review-card');
        if (!card) return 320;
        var style = window.getComputedStyle(track);
        return card.getBoundingClientRect().width + parseFloat(style.columnGap || style.gap || 0);
      };
      var prevReview = root.querySelector('[data-sep-review-prev]');
      var nextReview = root.querySelector('[data-sep-review-next]');
      if (prevReview) prevReview.addEventListener('click', function () {
        track.scrollBy({ left: -reviewStep(), behavior: 'smooth' });
      });
      if (nextReview) nextReview.addEventListener('click', function () {
        track.scrollBy({ left: reviewStep(), behavior: 'smooth' });
      });
    }

    setActiveMedia(0);
    updateSelectedVariant();
  });
})();
